<!--  -->
<template>
  <v-os-popup
    :show="isShow"
    title="选版本看评价"
    @close="close"
    :footerShow="false"
    class="vPopup"
    :maxHeightFill="isLowAndroid"
    :disableContentPd="true"
    container="body"
  >
    <div class="container">
      <!-- 商品信息预览 -->
      <div class="product-info">
        <img class="img" :src="productImg || skuInfo.imageInfos[0].smallPic" alt="" />
        <div class="name">
          {{ spuInfo.commoditySpu.spuName }}
          <p class="desc" v-if="(currVersion && currVersion.name) || (currColor && currColor.name)">
            已选：{{ currVersion && currVersion.name | formatVersionName }} {{ currColor && currColor.name }}
          </p>
          <p class="desc" v-else>请选择版本颜色</p>
        </div>
      </div>
      <!-- 商品规格选择 -->
      <div class="version-container">
        <div class="info">
          <div class="title">版本</div>
          <div class="version-list">
            <div
              class="version-item"
              :class="{
                selected: (currVersion && currVersion.name) === item.name,
                disabled: selectedColorIndex !== -1 && !isValidateSku(index, selectedColorIndex)
              }"
              v-for="(item, index) in versions"
              :key="item.name + index"
              @click="changeVersionIndex(index)"
            >
              {{ item.name | formatVersionName }}
            </div>
          </div>
        </div>
        <div class="info">
          <div class="title">颜色</div>
          <div class="color-list">
            <div
              class="color-item"
              :class="{
                selected: selectedColorIndex === index,
                disabled: selectedVersionIndex !== -1 && !isValidateSku(selectedVersionIndex, index)
              }"
              v-for="(item, index) in colors"
              :key="index"
              @click="changeColorIndex(index)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部确认模块 -->
    <div class="footer" slot="footer">
      <div class="reset" @click="clearSelectIndex">重置</div>
      <div class="confirm" @click="confirm">确定</div>
    </div>
  </v-os-popup>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import env from '@/utils/clientEnv'
import sku from './sku'
import { mapState, mapGetters } from 'vuex'
import { getSimpleSkuReq } from '../../../../../detail/index/api'

export default {
  name: 'SelectVersionPopup',
  //import引入的组件需要注入到对象中才能使用
  components: {},
  mixins: [sku()],
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    //这里存放数据
    return {
      isLowAndroid: env.isLowAndroid,
      productImg: ''
    }
  },
  computed: {
    ...mapState('detailv3', ['spuInfo', 'skuInfo']),
    ...mapGetters('detailv3', ['spuId']),
    specItem() {
      return this.spuInfo.specItem
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 如果规格名字中有@符号，则将@符号替换为空格
    formatSpecName(str) {
      // return str.replace(/@/, ' ')
      return str?.indexOf('@') > 0 ? str.split('@')[1] : str
    },
    close(data) {
      this.$emit('close', data)
    },
    async skuChange() {
      // 获取商品图片及名称
      if (this.currSkuId) {
        const res = await getSimpleSkuReq({
          skuId: (this.currSkuId + '').split(',')[0],
          spuId: this.spuId
        })
        this.productImg = res.imageInfos[0].smallPic
      }
    },
    confirm() {
      let versionName = this.currVersion ? this.formatSpecName(this.currVersion.name) : ''
      let colorName = this.currColor ? this.currColor.name : ''
      this.close({
        skuId: this.currSkuId,
        selectedText: versionName + ' ' + colorName
      })
    }
  }
}
</script>
<style lang="scss" src="./index.scss" scoped></style>
<style lang="scss" scoped src="../../../../index/dark-popup.scss"></style>
